<template>
	<core-layout-content full>
		<core-layout-headline-and-actions>
			<template slot="headline">
				{{ $t("leads") }}
				<core-pagination-info
					:itemsPerPage="itemsPerPage"
					:numberOfItems="listing.numberOfItems"
					:currentPage="page"
				/>
			</template>
			<template slot="actions">
				<!-- <j-button 
          v-can:and="['writeLogins','writeInternals']"
          :to="`${$route.path}/create-update`">
          <crm-icon name="add" size="small" color="c5" />
          {{$t("create_rule")}}
        </j-button> -->
			</template>
		</core-layout-headline-and-actions>

		<!-- Search -->
		<div class="flex wrap xs-12 xs-left mb2">
			<div class="flex xs-12">
				<j-base-input-search
					:placeholder="$t('search_name_referral_code')"
					:value="searchTerm"
					@input="onSearch($event)"
				/>
				<j-button
					class="ml2"
					type="tertiary"
					v-if="searchTerm"
					@click="cancelSearch"
				>
					{{ $t("cancel") }}
				</j-button>
			</div>
		</div>

		<!-- Data Container -->
		<j-card class="bg5">
			<j-data-table
				:header="header"
				:list="computedList"
				:sortable="false"
				:isLoading="isLoading"
				@sort="onSort($event)"
			>
				<template slot="list" slot-scope="{ item }">
					<td v-for="(column, i) in header" :key="i">
						<template>
							<!-- Actions -->
							<template v-if="column.field === 'actions'"> </template>

							<!-- Name -->
							<template v-else-if="column.field === 'name'">
								<!-- <router-link :to="`create-update/${item.id}`" :append="true">{{item.name}}</router-link> -->
								<span class="c2 fw7">{{ item.name }}</span>
							</template>

							<!-- Others -->
							<template v-else>
								{{ item[column.field] }}
							</template>
						</template>
					</td>
				</template>
				<template slot="empty">
					{{ $t("errors.no_data") }}
				</template>
			</j-data-table>
		</j-card>

		<!-- Pagination -->
		<div class="flex xs-12 p4 xs-center mb15">
			<j-pagination
				:amount="listing.numberOfItems"
				:perPage="itemsPerPage"
				:activePage="page"
				@click="onPageChange($event)"
			/>
		</div>
	</core-layout-content>
</template>

<script>
import CrmIcon from "@/components/CrmIcon/"
import JButton from "@/components/JButton/"
import JCard from "@/components/JCard/"
import JDataTable from "@/components/JDataTable/"
import JBaseInputSearch from "@/components/JBaseInputSearch/"
import JPagination from "@/components/JPagination/"
import CorePaginationInfo from "@/modules/core/components/CorePaginationInfo"
import CoreLayoutContent from "@/modules/core/components/CoreLayoutContent"
import CoreLayoutHeadlineAndActions from "@/modules/core/components/CoreLayoutHeadlineAndActions"
import dayjs from "dayjs"
import api from "@/api/"
import crmConfig from "@/config/"
import get from "lodash.get"
import debounce from "lodash.debounce"

export default {
	components: {
		CrmIcon,
		JButton,
		JCard,
		JDataTable,
		JBaseInputSearch,
		JPagination,
		CorePaginationInfo,
		CoreLayoutContent,
		CoreLayoutHeadlineAndActions
	},

	data() {
		return {
			isLoading: false,

			// Actual fetched data
			listing: {
				numberOfItems: 0,
				list: []
			},

			// Search term
			searchTerm: null,

			// Pagination
			page: 1,
			itemsPerPage: 30,

			// Header of table
			header: [
				{
					field: "name",
					text: this.$t("name")
				},
				{
					field: "description",
					text: this.$t("description")
				},
				{
					text: this.$t("created"),
					field: "createdAt"
				},
				{
					text: this.$t("actions"),
					field: "actions"
				}
			]
		}
	},

	computed: {
		computedList() {
			return this.listing.list.map(item => ({
				...item,
				name: `${item.name}`,
				description: `Some ${item.name} nice descritpion here`,
				createdAt: item.createdAt
					? dayjs(item.createdAt).format(
							this.$store.state.settings.dateTimeFormat
					  )
					: null
			}))
		}
	},

	methods: {
		onPageChange(pageIndex) {
			this.page = pageIndex
			this.readAll()
			this.scrollToTop()
		},

		scrollToTop() {
			this.$scrollTo("body", 300)
		},

		onSearch: debounce(function(value) {
			const payload = value === null || value === "" ? null : value
			this.searchTerm = value
			this.page = 1
			this.readAll()
		}, 200),

		cancelSearch() {
			this.searchTerm = null
			this.page = 1
			this.onSearch()
		},

		async reinviteUser(loginId) {
			const clientId = crmConfig.CLIENT_ID
			const res = await api.users.resendConfirmationEmail({
				clientId,
				loginId
			})

			if (res.errors) {
				res.errors.forEach(err =>
					this.$store.dispatch("addMessage", {
						message: { type: "error", text: err }
					})
				)
			} else {
				this.$store.dispatch("addMessage", {
					message: {
						type: "success",
						text: this.$t("user_reinvited")
					}
				})
			}
		},

		async readAll() {}
	},

	mounted() {
		this.readAll()
	}
}
</script>
